import styled from "styled-components"

import {LatoLight} from "@irati/ui/src/global/fonts"

export default styled.span`
  text-transform: uppercase;
  font-size: 11px;
  margin: 0 0 0 5px;
  white-space: normal;
  ${LatoLight}
`
